export const Inroduction = () => {
  return (
    <div className="pb-6">
      <div className="title text-lg font-bold">Introduction</div>
      <div className="mt-4">
        Medcursor Corporation, located at 2160 BARRANCA PARKWAY #1092 IRVINE, CA
        92606, its subsidiaries and/or affiliates ("Medcursor", "we", "us", or
        "our") provides mobile applications to connect and control various home
        and residential building smart devices and systems. Medcursor mobile
        applications for smart home devices enable features such as:
        <ol className="list-disc pl-8 mt-2 text-gray666 dark:text-white60">
          <li>
            Remote control of devices and systems by any Internet-connected
            device
          </li>
          <li>Creation and implementation of custom schedules and timers</li>
          <li>Promoting savings on energy costs by monitoring energy usage</li>
        </ol>
      </div>

      <div className="mt-4">
        We know the importance of privacy to our users, and we strive to be
        clear about how we collect, use, disclose, transfer, and store your
        personal information. Consequently, we have written this privacy policy
        to describe our privacy practices. If you are located in a member state
        of the European Economic Area(“EEA”), you may have different rights
        stated here.
      </div>
      <div className="mt-4">
        This policy applies to information we collect:
        <ol className="list-disc pl-8 mt-2 text-gray666 dark:text-white60">
          <li>On our websites at www.medcursor.com.</li>
          <li>
            When we use phone, email, postal mail, text messages, or other forms
            of electronic communication to communicate with you.
          </li>
          <li>
            When you access and post information on our social media sites.
          </li>
        </ol>
      </div>
      <div className="mt-4">
        Medcursor has social media accounts on including but not limited
        LinkedIn, Facebook, and Twitter. This policy appears on our website and
        is referenced in our social media profiles.
      </div>
    </div>
  );
};
